import { MIMETYPE_KML } from '@disy/lib/media-type';

import { AbstractDataViewExportAction } from 'cadenza/actions/table/abstract-data-view-export-action';
import type { ExportActionContext } from 'cadenza/workbook/actions/export-actions';
import type { DataViewId } from 'cadenza/workbook/model/data-view-id.gen';
import { isMapFullscreenSidebarModalOpen } from 'cadenza/workbook/ui/map-fullscreen-sidebar-modal/map-fullscreen-sidebar-modal-utils';

import i18n from './export-kml-action.properties';

export class ExportKmlAction extends AbstractDataViewExportAction {
  readonly #dataViewId;
  readonly #actionContext;

  constructor(dataViewId: DataViewId, actionContext: ExportActionContext) {
    super(dataViewId, actionContext, MIMETYPE_KML, {
      label: i18n('action.label'),
      dialogTitle: i18n('dialog.title'),
    });
    this.#dataViewId = dataViewId;
    this.#actionContext = actionContext;
  }

  override async execute() {
    const { KmlExportDialog } = await import('cadenza/kml-export-dialog/kml-export-dialog');
    const dialog = new KmlExportDialog(i18n('dialog.title'), this.#dataViewId, this.#actionContext);
    dialog.connectAndShow({ hidePreviousModals: !isMapFullscreenSidebarModalOpen() });
  }

  override get enabledSync() {
    return true;
  }
}
